import { Activity, FC, Fragment } from 'react';
import { Box } from '@mui/material';

import { PageContentPadding } from '@components/base/layout/utils';

import useTabContext from './useTabContext';

export const TabPanels: FC = () => {
  const { tabs, getContentId, getLabelId, selectedTab } = useTabContext();

  return (
    <Fragment>
      {tabs.map(
        ({
          BoxProps: { p = PageContentPadding, ...boxProps } = {},
          content,
          value,
          wrapperProps,
        }) => (
          <Box
            aria-labelledby={getLabelId(value)}
            hidden={selectedTab !== value}
            id={getContentId(value)}
            key={value}
            role='tabpanel'
            {...(selectedTab === value ? { ...wrapperProps } : {})}
          >
            <Activity mode={selectedTab === value ? 'visible' : 'hidden'}>
              <Box p={p} {...boxProps}>
                {content}
              </Box>
            </Activity>
          </Box>
        )
      )}
    </Fragment>
  );
};
